/**
 * Central registry for public-facing legal document URLs.
 *
 * Both values are intentionally kept here as a single source of truth so that
 * updating a URL only ever requires a one-line change in this file, regardless
 * of how many components reference it.
 */

export const TERMS_URL = 'https://docs.google.com/document/d/e/2PACX-1vRFh_AwCmdWUkhRIMFYCrXhGxvpi0YhYWWoockDBMQ1wDn6OlYGe-4td4VRGaBFfpGLBpctfWwX1FYk/pub';
export const PRIVACY_URL = 'https://docs.google.com/document/d/e/2PACX-1vT4I5mH__EYjB9Nc_iR-F8jkaNyK41ZAE1dtaLaZlDmYJvGeLHRQbi0SfWsUfgBp364n3iaIs9rIKP8/pub';
